export default () => ({
    itemId: "",
    variant: {},
    product: {},
    // Announced by this row's aria-live region. Only the +/- buttons write to
    // it — typing is already echoed by the screen reader.
    qtyMessage: "",

    init() {
        window.addEventListener("cartUpdate", (event) => {
            this.refreshLineItem();
        });
    },

    refreshLineItem() {
        const item = this.cart.lineItems.find((item) => item.id == this.itemId);
        if (!item) {
            return;
        }
        this.variant = item.purchasable;
        this.product = item.purchasable ? item.purchasable.product : null;
    },
});
